import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, change, changeType, icon, severity }) => {
  const getSeverityColor = () => {
    switch (severity) {
      case 'success':
        return 'text-success';
      case 'warning':
        return 'text-warning';
      case 'error':
        return 'text-error';
      default:
        return 'text-foreground';
    }
  };

  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 elevation-sm hover:elevation-md transition-smooth">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1">
          <p className="text-sm md:text-base font-caption text-muted-foreground mb-1">
            {title}
          </p>
          <h3 className={`text-2xl md:text-3xl lg:text-4xl font-heading font-semibold ${getSeverityColor()}`}>
            {value}
          </h3>
        </div>
        <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10">
          <Icon name={icon} size={24} color="var(--color-primary)" />
        </div>
      </div>
      {change && (
        <div className="flex items-center gap-1">
          <Icon 
            name={changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
            size={16} 
            className={getChangeColor()}
          />
          <span className={`text-xs md:text-sm font-caption ${getChangeColor()}`}>
            {change}
          </span>
        </div>
      )}
    </div>
  );
};

export default MetricCard;